<script>
	const util = require('../utilities');
	const accountService = require('services/accountService');
	const userContext = require('core/userContext');
	const page = require('page');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},
		props: {
			'modal-title': {
				default: 'Set Password',
				type: String
			},
			'min-length': {
				required: false,
				default: 8,
				type: Number
			},
			'max-length': {
				required: false,
				default: 32,
				type: Number
			},
			'button-text': {
				type: String,
				default: 'Set Password'
			},
			'extra-data': {
				required: false,
				type: Object,
				default: null
			},
			mode: {
				type: String,
				required: true
			},
			'modal-id': {
				default: 'modal-change-password',
				type: String
			},
			'prompt-for-current': {
				type: Boolean,
				default: false
			},
			'validation-off': {
				type: Boolean,
				default: false
			},
			'visible-password': {
				type: Boolean,
				default: false
			},
			confirm: {
				type: Boolean,
				default: false
			}
		},
		data: function () {
			return {
				modalPasswordForm: {
					password: ''
				}
			};
		},
		methods: {
			submitHandler: function (data) {
				if (this.mode === 'teacher') {
					return accountService.teacherChangePassword(data);
				} else if (this.mode === 'student') {
					return accountService.teacherChangeStudentPassword(data);
				} else {
					throw new Error('Unknown mode: ' + this.mode);
				}
			}
		},
		mounted() {
			var self = this;

			self.$watch(
				'promptForCurrent',
				function (p) {
					if (p) {
						self.modalPasswordForm.currentPassword = '';
					}
				},
				{
					immediate: true
				}
			);

			pubsub.subscribe('before-submit', function (evData) {
				if (evData.formName !== 'modalPasswordForm') {
					return true;
				}

				self.modalPasswordForm = $.extend(true, {}, self.modalPasswordForm, self.extraData || {});

				return true;
			});

			pubsub.subscribe('submit-succeeded', function (evData) {
				if (evData.formName !== 'modalPasswordForm') {
					return true;
				}
				util.closeModals();

				self.modalPasswordForm.password = '';

				pubsub.publish('message-success', 'Changed password');

				return true;
			});

			this.$subscribe('modal-closed', function (id) {
				if (id !== 'modal-post-reset-password-change') {
					return true;
				}

				let user = userContext.getUserData();

				// If user doesn't have first and last name.
				// Most likely drupal user, but regardless we need first and last name.
				if (!user.firstName || !user.lastName) {
					let newPassword = self.modalPasswordForm.password;

					// Is user filled out the form, we need first and last name
					if (newPassword) {
						let opts = {
							email: user.email,
							password: newPassword,
							f: user.firstName,
							l: user.lastName
						};
						util.openModal('#drupal-name-modal', opts);
					} else {
						// User did not fill out password form
						// And can't be allowed to navigate the site as they are missing data
						userContext.reset();
						page('/#login');
					}
				} else if (user && user.fromDrupal) {
					// Drupal user has names, just send to user setup.
					page('/my-account#!myAccountTab:about/');
				}
				// reset data so the dialog can be reused
				self.modalPasswordForm.password = '';
				if (self.promptForCurrent) {
					self.modalPasswordForm.currentPassword = '';
				}

				return false;
			});
		}
	};
</script>
<template>
	<div
		:id="modalId"
		class="modal"
		data-modal-window>
		<div class="modal-container">
			<div class="modal-window">
				<div class="modal-window-wrap">
					<button
						class="modal-close"
						data-modal-close>
						<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
					</button>
					<section class="modal-content">
						<header class="modal-content-header">
							<h2>{{ modalTitle }}</h2>
						</header>
						<div class="modal-content-main -form">
							<form-submitter
								form-name="modalPasswordForm"
								:form-data.sync="modalPasswordForm"
								:submit-to="submitHandler"
								class="form"
								novalidate
								no-close-modal>
								<auto-form-row
									v-if="promptForCurrent"
									type="password"
									class="label-hidden-visually"
									:data.sync="modalPasswordForm.currentPassword"
									label="Current Password"
									placeholder="Current Password"
									no-server-validation-messages
									required>
								</auto-form-row>
								<auto-form-row
									:visible-password="visiblePassword"
									:type="confirm ? 'confirmedPassword' : 'password'"
									row-class="label-hidden-visually"
									:min-length="minLength"
									:max-length="maxLength"
									:data.sync="modalPasswordForm.password"
									:placeholder="confirm ? 'New Password|Confirm New Password' : 'New Password'"
									:novalidate="validationOff"
									:login-password="mode"
									required>
								</auto-form-row>
								<auto-form-row
									row-class="-full-width"
									:all-valid="modalPasswordForm.allValid"
									type="submit">
									{{ buttonText }}
								</auto-form-row>
							</form-submitter>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
	<!-- end #modal-change-password -->
</template>
